module.exports = __webpack_public_path__ + "static/img/shouquan.134feb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shouquan.jpg
// module id = z5oL
// module chunks = 0